module.exports = __webpack_public_path__ + "img/animals_redpanda.6e6871b6.png";